import TitleIcon from "@mui/icons-material/WorkspacePremium";
import ListScientificDegrees from "./List";
import { SCIENTIFIC_DEGREES, EmployeeServicePath } from "utils/constants";
import CreateScientificDegree from "./Create";
import EditScientificDegree from "./Edit";
import ShowScientificDegree from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU],
  icon: <TitleIcon />,
  name: EmployeeServicePath + SCIENTIFIC_DEGREES,
  title: "Научни степени",
  list: <ListScientificDegrees />,
  create: <CreateScientificDegree />,
  createPermission: permissions.canCreateEmployeeTitles,
  edit: <EditScientificDegree />,
  editPermission: permissions.canUpdateEmployeeTitles,
  show: <ShowScientificDegree />,
  showPermission: permissions.canPreviewEmployeeTitles,
  permission: permissions.canPreviewEmployeeTitles,
};
